import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { BookOpen, Mail, ArrowDown } from "lucide-react";
import OrbitBackground from "@/components/common/OrbitBackground";
import StorybookCover from "@/components/common/StorybookCover";
import { INVESTOR_EMAIL, BOOK_META } from "@/lib/constants";

export default function StorybookHero() {
  return (
    <section className="relative overflow-hidden bg-[hsl(var(--kotz-ink))] min-h-[70vh] flex items-center">
      <OrbitBackground intensity="high" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 w-full">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7 order-2 lg:order-1">
            <Badge
              variant="outline"
              className="bg-[hsl(var(--kotz-gold))]/15 text-[hsl(var(--kotz-gold))] border-[hsl(var(--kotz-gold))]/50 font-mono text-[10px] tracking-[0.25em] uppercase"
            >
              <BookOpen className="h-3 w-3 mr-1" /> The Official Storybook
            </Badge>

            <h1 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl tracking-wider leading-[0.9] text-foreground">
              THE KOTZINONS
              <br />
              <span className="font-serif italic font-medium text-3xl sm:text-4xl lg:text-5xl gold-text normal-case tracking-normal">
                {BOOK_META.titleEn}
              </span>
            </h1>

            <p className="mt-5 text-base sm:text-lg text-foreground/70 max-w-xl text-balance leading-relaxed">
              The first published Kotzinons book by{" "}
              <span className="text-[hsl(var(--kotz-gold))] font-medium">{BOOK_META.author}</span> —
              a fully illustrated adventure where a boy named Moya meets Kotzinon and together they
              rally the heroes to protect a forest from being destroyed. A tale about friendship,
              courage, and the power of words to save a world.
            </p>

            <dl className="mt-7 grid grid-cols-2 sm:grid-cols-3 gap-4 max-w-lg text-xs font-mono uppercase tracking-widest">
              <div>
                <dt className="text-foreground/45">Author</dt>
                <dd className="text-foreground mt-1 normal-case tracking-normal font-sans text-sm">
                  {BOOK_META.author}
                </dd>
              </div>
              <div>
                <dt className="text-foreground/45">Publisher</dt>
                <dd className="text-foreground mt-1 normal-case tracking-normal font-sans text-sm">
                  {BOOK_META.publisher}
                </dd>
              </div>
              <div>
                <dt className="text-foreground/45">Copyright</dt>
                <dd className="text-foreground mt-1 normal-case tracking-normal font-sans text-sm">
                  {BOOK_META.copyright}
                </dd>
              </div>
            </dl>

            <div className="mt-7 flex flex-wrap gap-3">
              <Button
                asChild
                size="lg"
                className="rounded-xl gap-2 bg-[hsl(var(--kotz-gold))] text-[hsl(var(--kotz-ink))] hover:bg-[hsl(var(--kotz-gold))]/90 font-bold"
                data-testid="storybook-explore-cta"
              >
                <a href="#book-details">
                  Explore the book <ArrowDown className="h-4 w-4" />
                </a>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="rounded-xl border-border bg-transparent text-foreground hover:bg-foreground/5"
                data-testid="storybook-license-cta"
              >
                <a href={`mailto:${INVESTOR_EMAIL}?subject=Storybook%20Licensing%20%26%20Translation`}>
                  <Mail className="h-4 w-4 mr-1" /> Licensing & translation
                </a>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-5 order-1 lg:order-2 flex justify-center">
            <StorybookCover size="lg" ribbonText="© 2018" />
          </div>
        </div>
      </div>
    </section>
  );
}
